<script>
</script>

<img
    on:click={() => location.href = 'https://konnect-world.com'}
    src="/images/popup.jpg" 
    alt="" 
    style="width:100%;cursor:pointer;"
/>